// Transparent-background promo cutouts (person presenting the app). The section
// rotates through this pool, one per mount. Per-client gallery assets.
const PERSON_IMAGES = [
    '/media/maestroshield-whitelable/gallery/1789408919616-0.png',
    '/media/maestroshield-whitelable/gallery/1788954937970-0.png',
];

const QuickCallData = {
    en: {
        title: 'Ready to Get Started?',
        subtitle: "Let's Talk",
        paragraph: "Book a free, no obligation call and we'll help you find the right solution for your needs, no pressure, just honest answers.",
        btnText: 'Book a Free Call',
        media: '/placeholder.svg',
        personImages: PERSON_IMAGES,
    },

    // Hebrew copy is English for now, matches system_data_he (pending translation).
    he: {
        title: 'Ready to Get Started?',
        subtitle: "Let's Talk",
        paragraph: "Book a free, no obligation call and we'll help you find the right solution for your needs, no pressure, just honest answers.",
        btnText: 'Book a Free Call',
        media: '/placeholder.svg',
        personImages: PERSON_IMAGES,
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getQuickCallData(language) {
    const lang = resolveLanguage(language);
    return QuickCallData[lang] || QuickCallData.en;
}

export default QuickCallData;